import {Alert} from "@mantine/core";
import {Navigate, Route, Routes} from "react-router";
import NavBar from "../../components/NavBar/NavBar";
import {useUser} from "../../utils/api";
import Subscriptions from "../admin/Subscriptions";
import UsersPage from "../admin/Users";
import FactionsPage from "../admin/Factions";
import ArchiveList from "../bounty-hunting/ContractList/ArchiveList";
import CompletedList from "../bounty-hunting/ContractList/CompleteList";
import ContractDetails from "../bounty-hunting/Details/ContractDetails";
import ContractList from "../bounty-hunting/ContractList/ContractList";
import HeatMap from "../bounty-hunting/HeatMap/HeatMap";
import ManageNetwork from "../bounty-hunting/Taverns/ManageNetwork";
import ViewTaverns from "../bounty-hunting/Taverns/ViewTaverns";
import TransferContract from "../bounty-hunting/TransferContract";
import CargoCalculator from "../cargo/CargoCalculator";
import FitoutCalculator from "../cargo/FitoutCalculator";
import RouteList from "../hyperlanes/RouteList.tsx";
import RouteDetailsPage from "../hyperlanes/RouteDetailsPage.tsx";
import ReportSightings from "../bounty-hunting/ReportSightings";
import InteractiveMap from "../map/InteractiveMap";
import {GNSArchive} from "../misc/GNSArchive";
import Comparison from "../subscription/Comparison";
import FactionLicenses from "../subscription/FactionLicenses";
import ManageSubscription from "../subscription/ManageSubscription";
import Subscribe from "../subscription/Subscribe";
import Vendors from "../vendors/Vendors";
import VendorDetails from "../vendors/VendorDetails";
import Wares from "../vendors/Wares";
import WareVendors from "../vendors/WareVendors";
import VisionTool from "../vision/VisionTool";
import FactionPrivs from "./FactionPrivs";
import LandingPage from "./LandingPage";
import SWCPermissions from "./SWCPermissions";
import Logs from "../admin/Logs";
import MediaUpload from "../files/MediaUpload";
import AdminFileDashboard from "../files/AdminFileDashboard";
import AsteroidFieldsPage from "../asteroid-fields/AsteroidFieldsPage.tsx";
import AsteroidFieldDetailPage from "../asteroid-fields/AsteroidFieldDetailPage.tsx";
import ProductionModulesPage from "../modules/production/ProductionModulesPage.tsx";
import ProductionModuleAccessPage from "../modules/production/ProductionModuleAccessPage.tsx";
import ProductionModuleDashboardPage from "../modules/production/ProductionModuleDashboardPage.tsx";
import ProductionModuleTimelinePage from "../modules/production/ProductionModuleTimelinePage.tsx";
import ProductionModuleDetailsPage from "../modules/production/ProductionModuleDetailsPage.tsx";
import ProductionModuleEntitiesPage from "../modules/production/ProductionModuleEntitiesPage.tsx";
import ProductionModuleSettingsPage from "../modules/production/ProductionModuleSettingsPage.tsx";
import ProductionModuleGuard from "../modules/production/ProductionModuleGuard.tsx";
import ProductionModuleMaterialsPage from "../modules/production/ProductionModuleMaterialsPage.tsx";
import ProductionModuleDatacardsPage from "../modules/production/ProductionModuleDatacardsPage.tsx";
import ProductionModulePlannerPage from "../modules/production/ProductionModulePlannerPage.tsx";
import ProductionModuleCalculatorPage from "../modules/production/ProductionModuleCalculatorPage.tsx";
import ModulesAdminPage from "../admin/Modules.tsx";

export default function AuthRoutes() {
    const {user} = useUser();

    if (!user.isEnabled) {
        return (
            <div>
                <Alert color="red">Your account has been disabled. If you think this is a mistake please contact Kaire Nat-Sa</Alert>
                <Routes>
                    <Route path="" element={<LandingPage/>}/>
                </Routes>
            </div>
        );
    } else {
        return (
            <NavBar showSurveyBanner={false}>
                <Routes>
                    <Route path="" element={<LandingPage/>}/>
                    <Route path="/bh/contracts" element={<ContractList/>}/>
                    <Route path="/bh/contracts/archive" element={<ArchiveList/>}/>
                    <Route path="/bh/contracts/complete" element={<CompletedList/>}/>
                    <Route path="/bh/contract/:id" element={<ContractDetails/>}/>
                    <Route path="/bh/contracts/transfer" element={<TransferContract />}/>
                    <Route path="/bh/reportSightings" element={<ReportSightings/>}/>
                    <Route path="/bh/heatmap" element={<HeatMap/>}/>
                    <Route path="/bh/taverns" element={<ViewTaverns />}/>
                    <Route path="/bh/taverns/:view/:network" element={<ViewTaverns />}/>

                    {user.privs.manageTavernNetwork || user.isAdmin ? <>
                        <Route path="/bh/network/manage" element={<ManageNetwork/>}/>
                    </> : null}

                    <Route path="/hl/routes" element={<RouteList/>}/>
                    <Route path="/hl/routes/:id" element={<RouteDetailsPage/>}/>

                    <Route path="/user/api-permissions" element={<SWCPermissions />}/>

                    <Route path="/subscribe" element={<Subscribe />}/>
                    <Route path="/subscribe/manage" element={<ManageSubscription />}/>
                    <Route path="/subscribe/pricing" element={<Comparison />}/>

                    {user.subLevel > 0 ? (
                        <>
                        <Route path="/vision" element={<VisionTool />}/>
                        <Route path="/vision/:id" element={<VisionTool />}/>
                        <Route path="/map" element={<InteractiveMap />}/>
                        <Route path="/map/:id" element={<InteractiveMap />}/>
                        <Route path="/files" element={<MediaUpload />}/>
                        </>
                    ) : null}

                    <Route path="/cargo/calculator" element={<Navigate to="/cargo/cargo" replace={true}/> }/>

                    <Route path="/cargo/cargo" element={<CargoCalculator />}/>
                    <Route path="/cargo/cargo/:id" element={<CargoCalculator />}/>
                    <Route path="/cargo/fitout" element={<FitoutCalculator />}/>
                    <Route path="/cargo/fitout/:id" element={<FitoutCalculator />}/>

                    <Route path="/gns/archive/:activeTab" element={<GNSArchive />} />
                    <Route path="/asteroid-fields" element={<AsteroidFieldsPage />} />
                    <Route path="/asteroid-fields/:id" element={<AsteroidFieldDetailPage />} />
                    <Route path="/modules/production" element={<ProductionModulesPage />} />
                    <Route path="/modules/production/:moduleId" element={<Navigate to="dashboard" replace={true}/>} />
                    <Route path="/modules/production/:moduleId/dashboard" element={<ProductionModuleGuard><ProductionModuleDashboardPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/timeline" element={<ProductionModuleGuard><ProductionModuleTimelinePage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/details" element={<ProductionModuleGuard><ProductionModuleDetailsPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/materials" element={<ProductionModuleGuard><ProductionModuleMaterialsPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/datacards" element={<ProductionModuleGuard><ProductionModuleDatacardsPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/planner" element={<ProductionModuleGuard><ProductionModulePlannerPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/calculator" element={<ProductionModuleGuard><ProductionModuleCalculatorPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/entities" element={<ProductionModuleGuard><ProductionModuleEntitiesPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/management" element={<Navigate to="../entities" replace={true} relative="path"/>} />
                    <Route path="/modules/production/:moduleId/access" element={<ProductionModuleGuard><ProductionModuleAccessPage /></ProductionModuleGuard>} />
                    <Route path="/modules/production/:moduleId/settings" element={<ProductionModuleSettingsPage />} />

                    <Route path="/faction" element={<FactionPrivs />} />
                    <Route path="/faction/licenses" element={<FactionLicenses />} />

                    <Route path="/vendors" element={<Vendors />} />
                    <Route path="/vendors/:vendorId" element={<VendorDetails />} />
                    <Route path="/wares" element={<Wares />} />
                    <Route path="/wares/:type/:wareKey" element={<WareVendors />} />

                    {user.isAdmin ? (
                        <>
                            <Route path="/admin/users" element={<UsersPage />}/>
                            <Route path="/admin/factions" element={<FactionsPage />}/>
                            <Route path="/admin/subscriptions" element={<Subscriptions />}/>
                            <Route path="/admin/modules" element={<ModulesAdminPage />}/>
                            <Route path="/admin/logs" element={<Logs />}/>
                            <Route path="/admin/files" element={<AdminFileDashboard />}/>
                        </>
                    ) : null}
                </Routes>
            </NavBar>

        )
    }
}
